<template>
    <div :class="classes">
        <div v-show="showPopup" class="c-prompt">
            <div class="c-prompt-text">
                <!-- <p>You have empty fields! Do you want to proceed?</p> -->
                <p>{{promptText}}</p>
                <div class="c-buttons">
                    <button class="c-button" @click="cancelConfirm" type="button">Go Back</button>
                    
                    <button class="c-button" @click="acceptConfirm" type="button">Proceed</button>
                </div>
                <!-- /.c-buttons -->
            </div>
            <!-- /.c-prompt-text -->
        </div>
        <!-- /.prompt -->
        <btn
            class="c-progress-button--prev"
            :prev="true"
            text="Previous"
            @clicked="handlePrev"
            :disabled="currentStep === 0 && currentStepPart === 0"
        />

        <div class="c-progress-bar">
            <span
                v-for="n in steps.length + 1"
                :key="n"
                :class="{'active': n - 1 <= currentStep, 'current': n -1 === currentStep}"
            >
                <span class="inner" v-if="steps[n-1]">{{steps[n-1].title}}</span>
            </span>

            <div :style="{'width': progressWidth}" class="c-progress-bar--dynamic"></div>
        </div>

        <btn
            class="c-progress-button--next"
            :next="true"
            text="Next"
            @clicked="handleNext"
            v-if="currentStep !== maxSteps"
        />

        <router-link
            class="c-progress-button--next c-button c-button--next"
            v-if="currentStep === maxSteps"
            to="/results"
        >Next</router-link>
    </div>
</template>

<script>
    import Button from "components/button/button.vue";
    import steps from "../../data";
    import { mapGetters } from "vuex";
    import StepVue from "../step/Step.vue";

    export default {
        components: {
            btn: Button
        },

        data() {
            return {
                steps,
                showPopup: false,
                promptText: ""
            };
        },

        props: {
            currentStep: {
                type: Number,
                required: true
            },

            currentStepPart: {
                type: Number,
                required: true
            },

            currentStepParts: {
                type: Number,
                required: true
            },

            maxSteps: {
                type: Number,
                required: true
            },

            onPrev: {
                type: Function,
                required: true
            },

            onNext: {
                type: Function,
                required: true
            }
        },

        computed: {
            classes() {
                return {
                    "c-progress": true
                };
            },

            ...mapGetters({ getSteps: "steps" }),

            progressWidth() {
                const currentSubStep = this.currentStepPart;
                const subStepsLength = this.currentStepParts;
                const step = 100 / this.steps.length;

                const correction =
                    currentSubStep || currentSubStep === 2
                        ? (step / subStepsLength) * (currentSubStep + 1)
                        : step / subStepsLength;

                const progress =
                    (this.currentStep / this.steps.length) * 100 + correction;
                return `${progress}%`;
            }
        },

        methods: {
            handlePrev() {
                this.onPrev();
            },

            handleNext() {
                const renderedRows = this.steps[this.currentStep].rows[
                    this.currentStepPart
                ];
                const expectedValidRows = renderedRows.length;
                const rowsIdsToValidate = renderedRows.map(row => row.id);

                let validRows = 0;
                const maxRowsPerSubStep = 4;
                const filterFrom = this.currentStepPart * maxRowsPerSubStep;
                const filterTo = filterFrom + expectedValidRows;
                this.getSteps[this.currentStep].rows
                    .filter(row => rowsIdsToValidate.indexOf(row.rowIndex) > -1)
                    .forEach(row => {
                        let isFrequencyValid = this.validateFrequency(row);
                        let isAmountValid = this.validateAmount(row);

                        if (!(isFrequencyValid && isAmountValid)) {
                            return;
                        }

                        validRows++;
                    });

                this.showPopup = false;
                if (validRows === expectedValidRows) {
                    return this.onNext();
                }

                this.promptText = "You have empty fields! Do you want to proceed?";
                this.showPopup = true;
            },

            validateAmount(field) {
                if (typeof field.amount === "undefined") {
                    return false;
                }

                return (
                    parseFloat(field.amount) == field.amount &&
                    parseFloat(field.amount) > 0
                );
            },

            validateFrequency(field) {
                if (typeof field.spendFrequency === "undefined") {
                    return false;
                }

                const regex = /^([1-9]\d*)$/g;
                return field.spendFrequency.toString().match(regex);
            },

            cancelConfirm() {
                this.showPopup = false;
            },

            acceptConfirm() {
                this.cancelConfirm();
                this.onNext();
            }
        }
    };
</script>

<style lang="scss">
    .c-progress {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 2.25rem;

        &-bar {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 65%;
            position: relative;

            @media screen and (max-width: 1020px) {
                width: 60%;
            }

            @media screen and (max-width: 1020px) {
                display: none;
            }

            &:before {
                content: "";
                position: absolute;
                width: 100%;
                height: 0.1875rem;
                background-color: #979797;
                top: 50%;
                transform: translateY(-50%);
                z-index: 1;
            }

            &--dynamic {
                position: absolute;
                top: 50%;
                left: 0;
                right: 0;
                transform: translateY(-50%);
                background-color: #f98155;
                height: 0.1875rem;
                z-index: 2;
                transition: width 1s ease;
            }

            span {
                width: 0.75rem;
                height: 0.75rem;
                border-radius: 50%;
                background-color: #979797;
                position: relative;
                padding-top: 10px;
                position: relative;
                z-index: 5;
                transition: background-color 1s ease;

                .inner {
                    background-color: transparent;
                    position: absolute;
                    font-size: 0.875rem;
                    width: 9.375rem;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%);
                    opacity: 0;
                    text-align: center;
                    font-family: "Montserrat", sans-serif;
                    transition: opacity 0.5s ease;
                }

                &.active {
                    background-color: #f98155;
                }

                &.current {
                    .inner {
                        opacity: 1;
                    }
                }
            }
        }

        &-button {
            &--prev {
                position: relative;

                &::before {
                    content: "";
                    width: 0.5625rem;
                    height: 0.5625rem;
                    display: block;
                    position: absolute;
                    top: 0px;
                    left: 0.6875rem;
                    bottom: 0%;
                    margin: auto;
                    border-width: 0 0 1px 1px;
                    border-style: solid;
                    border-color: #fff;
                    transform: rotate(45deg);
                }
            }

            &--next {
                position: relative;
                line-height: 1.15;

                &::after {
                    content: "";
                    width: 0.5625rem;
                    height: 0.5625rem;
                    display: block;
                    position: absolute;
                    top: 0;
                    right: 1.125rem;
                    bottom: 0%;
                    margin: auto;
                    border-width: 0 0 1px 1px;
                    border-style: solid;
                    border-color: #fff;
                    transform: rotate(225deg);
                }
            }
        }
    }

    .c-prompt {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: rgba(165, 162, 162, 0.5);
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;

        &-text {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            min-width: 31.25rem;
            text-align: center;
            min-height: 12.5rem;
            display: flex;
            justify-content: center;
            flex-direction: column;
            border-radius: 0.3125rem;
            background-color: #fff;
            padding: 1rem;

            p {
                align-self: center;
                margin: 0;
                padding-bottom: 2rem;
            }
        }

        .c-buttons {
            button {
                background-color: #f98155;
                min-width: 6.25rem;
                border: 1px solid transparent;
                border-radius: 0.3125rem;
                padding: 0.3125rem 0.625rem;
                margin: 0 0.625rem;

                &:hover {
                    background-color: #fff;
                    border: 1px solid #f98155;
                    color: #f98155;
                }
            }
        }

        @media screen and (max-width: 767px) {
            &-text {
                min-width: 90%;
            }
        }
    }
</style>
